import React from 'react';
import ReactDOM from 'react-dom/client';
import './leafletRotate';
import 'leaflet-rotate';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('container') as HTMLElement);
root.render(<App />);
